import styled from "@emotion/styled";
import selectArrow from "images/pc/select-arrow.svg";
import calendarArrow from "images/pc/calendar-arrow.svg";
import checkboxOff from "images/pc/checkbox-off.svg";
import checkboxOn from "images/pc/checkbox-on.svg";
import checkboxDisabled from "images/pc/checkbox-disabled.svg";
import close from "images/pc/button-close.svg";

export const Section = styled.div`
  padding-left: 20px;
  padding-right: 20px;

  &.noSpace {
    padding-left: 0;
    padding-right: 0;
  }

  .error-text {
    display: block;
    padding-top: 4px;
    font-size: 12px;
    color: ${props => props.theme.colors.secondary};
  }
`;

export const TitleGroup = styled.div`
  .title {
    margin-bottom: 10px;
  }
  .button {
    margin-top: 16px;
  }
  .titleRow {
    display: flex;
    align-items: baseline;
    justify-content: space-between;

    .count {
      font-size: ${props => props.theme.text.sizeFont};
      color: ${props => props.theme.colors.primary};
    }
  }
`;

export const Title = styled.h2`
  margin-top: 60px;
  margin-bottom: 20px;
  font-size: ${props => props.theme.title.sizeFont};
  font-weight: ${props => props.theme.weight.extraBold};

  &.first {
    margin-top: 0;
  }
`;

export const TitleBig = styled.h2`
  font-size: ${props => props.theme.title.sizeFontL};
  font-weight: ${props => props.theme.weight.extraBold};
`;

export const TitleBox = styled.div`
  margin-bottom: 30px;
  text-align: center;

  .desc {
    margin-top: 11px;
  }
`;

export const Desc = styled.div`
  color: ${props => props.theme.text.colorFont};
  font-size: ${props => props.theme.text.sizeFont};
`;

export const CheckBoxWrap = styled.span`
  display: inline-block;

  .input-check {
    display: inline-block;
    width: 22px;
    height: 22px;
    background: url(${checkboxOff}) no-repeat 0 0;
    background-size: contain;
    vertical-align: top;
  }
  input {
    border: 0;
    clip: rect(0, 0, 0, 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }
  input:checked + .input-check {
    background-image: url(${checkboxOn});
  }
  input:disabled + .input-check {
    background-image: url(${checkboxDisabled});
  }
`;

export const Divider = styled.hr`
  border: 0;
  border-top: 1px solid ${props => props.theme.colors.divider};

  &.mt50 {
    margin-top: 50px;
  }
`;

export const TermsPopupContents = styled.div``;

export const ButtonLine = styled.button`
  height: 30px;
  padding: 1px 14px 0;
  border: 1px solid ${props => props.theme.button.colorLine};
  border-radius: 3px;
  color: ${props => props.theme.button.colorFont};
  font-size: 12px;

  &.add {
    width: 70px;
    padding-left: 0;
    padding-right: 0;
  }
  &.delete {
    width: 60px;
  }
`;

export const ButtonLineBig = styled.button`
  height: 50px;
  padding: 1px 10px 0;
  border: 1px solid ${props => props.theme.colors.primary};
  border-radius: ${props => props.theme.radius};
  color: ${props => props.theme.colors.primary};
  font-size: ${props => props.theme.text.sizeFontS};

  &.invert {
    background-color: ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.white};
    font-weight: ${props => props.theme.weight.bold};

    :disabled,
    &.disabled {
      background-color: ${props => props.theme.colors.white};
      font-weight: ${props => props.theme.weight.normal};
    }
  }

  :disabled,
  &.disabled {
    border: solid 1px ${props => props.theme.input.colorBorder};
    color: ${props => props.theme.text.colorFont};
  }

  &.secondary {
    border-color: ${props => props.theme.button.colorLine};
    color: ${props => props.theme.text.colorFont3};
  }
`;

export const ButtonRound = styled.button`
  width: 200px;
  height: 60px;
  border: 1px solid ${props => props.theme.colors.primary};
  border-radius: 60px;
  background-color: ${props => props.theme.colors.primary};
  color: ${props => props.theme.colors.white};
  font-size: ${props => props.theme.buttonRound.sizeFont};
  font-weight: 600;

  &.disabled {
    opacity: 0.2;
    cursor: not-allowed;
  }
`;

export const ButtonText = styled.button`
  color: ${props => props.theme.buttonText.colorFontDark};
  font-size: ${props => props.theme.buttonText.sizeFont};
  text-decoration: underline;
  letter-spacing: -0.12px;

  &.light {
    color: #8c8c8c;
  }
`;

export const ButtonLink = styled.a`
  color: ${props => props.theme.buttonText.colorFontDark};
  font-size: ${props => props.theme.buttonText.sizeFont};
  text-decoration: underline;
  letter-spacing: -0.12px;
`;

export const Label = styled.p`
  margin-top: 20px;
  margin-bottom: 6px;
  font-size: ${props => props.theme.label.sizeFont};
  font-weight: ${props => props.theme.weight.bold};
`;

export const InputText = styled.input`
  padding: 0 24px 0 16px;
  width: 100%;
  height: 50px;
  border: 1px solid ${props => props.theme.input.colorBorder};
  border-radius: 5px;

  &[data-error="true"] {
    border-color: ${props => props.theme.colors.secondary};
  }

  &[name="identificationBack"] {
    font-family: arial;
  }

  &:focus {
    border-color: ${props => props.theme.colors.primary};
  }

  &:disabled {
    background-color: ${props => props.theme.colors.white};
    cursor: not-allow;
  }
`;

export const RadioGroup = styled.div`
  display: flex;
`;

export const Radio = styled.label`
  flex: 1;

  input {
    display: none;
  }

  .radioButton {
    display: block;
    width: 60px;
    padding: 16px 12px 0;
    height: 50px;
    border: 1px solid ${props => props.theme.input.colorBorder};
    background-color: #fff;
    color: ${props => props.theme.colors.textSub};
    text-align: center;
  }

  &.full .radioButton {
    width: 100%;
  }

  input:checked + .radioButton {
    border-color: ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.primary};
  }

  &.first {
    .radioButton {
      border-right: 1px solid transparent;
      border-top-left-radius: ${props => props.theme.radius};
      border-bottom-left-radius: ${props => props.theme.radius};
    }
    input: checked + .radioButton {
      border-right-width: 1px;
    }
  }

  &.last {
    .radioButton {
      border-left: 1px solid transparent;
      border-top-right-radius: ${props => props.theme.radius};
      border-bottom-right-radius: ${props => props.theme.radius};
    }
    input: checked + .radioButton {
      border-left-width: 1px;
    }
  }
`;

export const SelectGroup = styled.div`
  display: flex;
  justify-content: space-between;

  .react-datepicker-wrapper,
  .react-datepicker__input-container {
    display: block;
  }
`;

export const SelectBox = styled.select`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 186px;
  padding: 2px 40px 0 16px;
  height: 50px;
  border: 1px solid ${props => props.theme.selectBox.colorBorder};
  border-radius: 5px;
  background: url(${selectArrow}) no-repeat right 0 top 2px;
  background-color: ${props => props.theme.colors.white};

  &.nonSelect {
    color: ${props => props.theme.placeholder.colorFont};
  }

  &[data-error="true"] {
    position: relative;
    z-index: 1;
    border-color: ${props => props.theme.colors.secondary};
  }
`;

export const DatePickerButton = styled.button`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  padding: 2px 40px 0 16px;
  height: 50px;
  border: 1px solid ${props => props.theme.selectBox.colorBorder};
  border-radius: 5px;
  background: url(${selectArrow}) no-repeat right 0 top 2px;
  background-color: ${props => props.theme.colors.white};
  text-align: left;
  letter-spacing: -0.5px;

  &.nonSelect {
    color: ${props => props.theme.placeholder.colorFont};
  }

  &[data-error="true"] {
    border-color: ${props => props.theme.colors.secondary};
  }

  &.react-datepicker-ignore-onclickoutside {
    border-color: ${props => props.theme.colors.primary};
  }
`;

export const DatePickerWrap = styled.div`
  width: 186px;

  .b-calendar {
    &.react-datepicker {
      position: relative;
      display: inline-block;
      font-family: ${props => props.theme.fonts.main};
      font-size: ${props => props.theme.calendar.sizeFont};
      color: ${props => props.theme.calendar.colorFont};
      border: 0;
      border-radius: 10px;
      box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.08);
    }
  }

  .react-datepicker__triangle {
    display: none;
  }

  .react-datepicker__day:not(.react-datepicker__day--disabled):hover, .react-datepicker__month-text:hover {
    border-radius: 0;
    background-color: inherit;
    color: ${props => props.theme.calendar.colorFont};

    &.react-datepicker__day--in-range {
      background-color: rgba(60,122,229,0.6);
      color: ${props => props.theme.colors.white}
    }

    &.react-datepicker__day--range-start,
    &.react-datepicker__day--range-end {
      background-color: ${props => props.theme.colors.primary};
    }
  }
  .react-datepicker__month-text--in-selecting-range:hover, .react-datepicker__month-text--in-range:hover {
    background-color: inherit;
  }
  .react-datepicker__header {
    padding-top: 27px;
    border-bottom: 0;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: ${props => props.theme.colors.white};
  }

  .react-datepicker__day-names {
    margin-top: 3px;
  }

  .react-datepicker__day-name,
  .react-datepicker__day,
  .react-datepicker__time-name {
    margin-top: 5px;
    margin-bottom: 5px;
    margin-left: 0;
    margin-right: 0;
    width: 40px;
    height: 40px;
    border: none;
    line-height: 40px;
  }

  .react-datepicker__day-name {
    color: ${props => props.theme.calendar.colorDisabled};
  }
  .react-datepicker__day {
    color: ${props => props.theme.calendar.colorFont};
  }

  .react-datepicker__day--keyboard-selected,
  .react-datepicker__month-text--keyboard-selected {
    border-radius: 0;
    background-color: inherit;
    color: inherit;
  }

  .react-datepicker__day--today {
    position: relative;
    font-weight: ${props => props.theme.weight.normal};
    color: ${props => props.theme.colors.primary};

    &:after {
      content: "Today";
      position: absolute;
      left: 50%;
      transform: translate(-50%, 0);
      bottom: 0;
      color: ${props => props.theme.colors.primary};
      font-size: ${props => props.theme.text.sizeFontXXS};
      line-height: 1.1;
    }

    &.react-datepicker__day:hover {
      color: ${props => props.theme.colors.primary};
    }
    &.react-datepicker__day--selected:after,
    &.react-datepicker__day--range-start:after {
      color: ${props => props.theme.colors.white};
    }
    &.react-datepicker__day--selected:hover {
      background-color: ${props => props.theme.colors.primary};
      color: ${props => props.theme.colors.white};
    }
    &.react-datepicker__day--highlighted:after {
      color: ${props => props.theme.colors.white};
    }
    &.react-datepicker__day--highlighted:hover {
      color: ${props => props.theme.colors.white};
    }
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--in-range,
  .react-datepicker__month-text--selected,
  .react-datepicker__month-text--in-selecting-range,
  .react-datepicker__month-text--in-range,
  .react0datepicker__day--today.react-datepicker__day--selected,
  .react-datepicker__day--highlighted {
    border-radius: 0;
    border-color: ${props => props.theme.colors.primary};
    background-color: ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.white};
  }
  .react-datepicker__day--selected {
    border-radius: 3px;
  }
  .react-datepicker__day--selected: hover {
    border-radius: 3px!important;
    border-color: ${props => props.theme.colors.primary};
    background-color: ${props => props.theme.colors.primary}!important;
    color: ${props => props.theme.colors.white}!important;
  }

  .react-datepicker__day--in-range, .react-datepicker__day--in-selecting-range, .react-datepicker__day.react-datepicker__day--in-selecting-range:hover {
    background-color: rgba(60, 122, 229, 0.6);
    border-radius: 0;
  }

  .react-datepicker__day--in-selecting-range, .react-datepicker__day.react-datepicker__day--in-selecting-range:hover {
    color: ${props => props.theme.colors.white};
  }

  .react-datepicker__day--in-range.react-datepicker__day--disabled {
    //color: ${props => props.theme.colors.white};
  }
  .react-datepicker__day--disabled.react-datepicker__day--range-start,
  .react-datepicker__day--disabled.react-datepicker__day--range-end,
  .react-datepicker__day--disabled.react-datepicker__day--highlighted {
    color: ${props => props.theme.colors.white};
  }

  .react-datepicker__day--disabled,
  .react-datepicker__month-text--disabled {
    color: ${props => props.theme.calendar.colorDisabled};
  }

  .react-datepicker__month {
    margin: 0 30px 40px 30px;
  }

  .react-datepicker__current-month,
  .react-datepicker-time__header {
    font-size: ${props => props.theme.calendar.sizeHeader};
  }

  .react-datepicker__current-month,
  .react-datepicker-time__header,
  .react-datepicker-year-header {
    color: ${props => props.theme.calendar.colorFont};
    font-weight: ${props => props.theme.weight.extraBold};
  }

  .react-datepicker__current-month {
    padding-top: 7px;
    padding-bottom: 6px;
  }

  .react-datepicker__day--range-start, .react-datepicker__day--range-end, .react-datepicker__day--disabled.react-datepicker__day--highlighted {
    background-color: ${props => props.theme.colors.primary};
    border-radius: 3px;
  }

  .react-datepicker__day--range-start {
    border-top-right-radius: 0px!important;
    border-bottom-right-radius: 0px!important;
  }

  .react-datepicker__day--range-end {
    border-top-left-radius: 0px!important;
    border-bottom-left-radius: 0px!important;
  }

  .react-datepicker__day--in-selecting-range {
  }

  .react-datepicker__day--selecting-range-start {
  }

  .react-datepicker__navigation {
    top: 27px;
    width: 40px;
    height: 39px;
    border: 0;
    background: url(${calendarArrow}) no-repeat 50% 50%;
  }
  .react-datepicker__navigation--next {
    transform: rotate(180deg);
    right: 28px;
  }
  .react-datepicker__navigation--previous {
    left: 28px;
  }
`;

export const PlaceholderText = styled.span`
  color: ${props => props.theme.placeholder.colorFont};
  letter-spacing: -0.5px;
`;

export const Notice = styled.p`
  margin-top: 8px;
  color: ${props => props.theme.text.colorFont};
  font-size: ${props => props.theme.text.sizeFont};
`;

export const ButtonCenterWrap = styled.div`
  padding-top: 50px;
  padding-left: 20px;
  padding-right: 0;
  text-align: center;

  &.line {
    margin-top: 30px;
    border-top: 1px solid ${props => props.theme.colors.divider};
  }
`;

export const SummaryBox = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
  padding: 22px 76px 22px 24px;
  border: 1px solid ${props => props.theme.input.colorBorder};
  border-radius: 5px;
  font-size: ${props => props.theme.text.sizeFont};
  line-height: 1.67;
  word-break: break-all;

  .group + .group {
    margin-top: 14px;
  }

  .title {
    font-weight: 600;
  }

  .edit {
    position: absolute;
    top: 50%;
    right: 9px;
    transform: translate(0, -50%);
    color: ${props => props.theme.colors.primary};
    font-size: ${props => props.theme.buttonText.sizeFontM};
    text-decoration: underline;
    letter-spacing: -0.12px;
    padding: 15px;
  }
`;

export const DashedBox = styled.div`
  padding-top: 15px;
  padding-bottom: 15px;
  border-top: 1px dashed ${props => props.theme.colors.border};

  &.first {
    border-top: 0;
  }

  &.last {
    padding-bottom: 0;
  }
`;

export const ButtonClose = styled.button`
  display: inline-block;
  width: 40px;
  height: 40px;
  background: url(${close}) no-repeat;
  vertical-align: top;
`;

export const PartialRegion = styled.p`
  margin-top: -30px;
  margin-bottom: 50px;
  color: ${props => props.theme.text.colorFont2};
  font-size: ${props => props.theme.text.sizeFont};
`;

export const Fieldset = styled.fieldset`
  &.disabled {
    position: relative;
    cursor: not-allowed;

    &:after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      display: block;
      width: 100%;
      height: 100%;
      background-color: ${props => props.theme.colors.white};
      opacity: 0.8;
    }
  }
`;

export const Popup = styled.div`
  z-index: 100;
  oveflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.6);

  .popupInner {
    position: relative;
    width: 920px;
    height: 540px;
    background-color: #fff;
    border-radius: ${props => props.theme.radius};
  }

  &.checkHistoryPopup .popupInner {
    padding: 50px;
    width: 480px;
    height: auto;
  }

  .popupClose {
    position: absolute;
    top: 0;
    right: -50px;
    color: #fff;

    @media (max-width: 1024px) {
      top: -40px;
      right: 0;
    }
  }
`;

export const HistoryContainer = styled.section`
  margin: 71px auto 0;
  padding-top: 80px;
  padding-bottom: 80px;
  width: 500px;
  min-height: calc(100vh - 356px);
  min-height: calc((var(--vh, 1vh) * 100) - 356px);

  &.narrow {
    width: 336px;
  }
`;

export const RowGroup = styled.div`
  display: flex;
  justify-content: space-between;
  & + & {
    margin-top: 8px;
  }
  .left {
    width: 55%;
  }
  .right {
    width: 42.27%;
  }
  .goBack {
    width: 38.77%;
  }
  .goNext {
    width: 58.5%;
  }
`;

export const ErrorText = styled.span`
  display: block;
  padding-top: 4px;
  font-size: 12px;
  color: ${props => props.theme.colors.secondary};
`;
